import moment from 'moment'

import { dateBackendDateTimeToRelativeTime, dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const DAYS_CONSIDERED_RECENT = 5

export const timeAgoWhenRecent = (date: string) => {
  const today = moment().utc().startOf('day')
  const tomorrow = moment().utc().startOf('day').add(1, 'day')
  const yesterday = moment().utc().startOf('day').subtract(1, 'day')

  if (today.isSame(date, 'd')) {
    return i18n.t('one_on_ones.meeting.date.today')
  }

  if (tomorrow.isSame(date, 'd')) {
    return i18n.t('one_on_ones.meeting.date.tomorrow')
  }

  if (yesterday.isSame(date, 'd')) {
    return i18n.t('one_on_ones.meeting.date.yesterday')
  }

  const differenceBetweenDates = Math.abs(today.diff(date, 'days'))
  const isOutsideRecentRange = differenceBetweenDates >= DAYS_CONSIDERED_RECENT

  return isOutsideRecentRange
    ? dateBackendDateTimeToUI(date)
    : dateBackendDateTimeToRelativeTime(date)
}
